/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { TextViewProps } from '@airasia-phoenix/react-native/components/TextView';

import { EmailFieldProps } from '@airasia-phoenix/react-native/components/EmailFieldView';

import {
  ButtonViewProps,
  ButtonViewType,
} from '@airasia-phoenix/react-native/components/ButtonView';

import { pd } from '@airasia-phoenix/react-native/utils';
import { getTextStyle } from '@airasia-phoenix/react-native/utils/utils';

export type ForgotPasswordProps = {
  headings: {
    greeting: TextViewProps;
    title: TextViewProps;
  };
  emailFieldProps: EmailFieldProps;
  onSendEmailSuccess?: (email: string) => void;
  onForgotPasswordError?: (error: Error) => void;
  onLoadingChange?: (loading: boolean) => void;
  onLoadingStateChange?: (isLoading: boolean) => void;
  primaryButtonProps: ButtonViewProps;
  onBackPress?: () => void;
  showHeader?: boolean | null;
};

export const defaultProps: ForgotPasswordProps = {
  headings: {
    greeting: {
      text: "We'll send an email with instructions to change your password.",
      style: getTextStyle(
        pd.sys.typescale.sub_body_text,
        pd.sys.colour.content_secondary,
      ),
    },
    title: {
      text: 'Forgot password',
      style: getTextStyle(
        pd.sys.typescale.body_text_medium,
        pd.sys.colour.content_primary,
      ),
    },
  },
  emailFieldProps: {
    label: 'Email',
    disabled: false,
    value: '',
    isError: false,
    errorMessage: 'Please enter a valid email',
    suggestions: [],
    onError: () => {},
  },
  primaryButtonProps: {
    text: 'Submit',
    type: ButtonViewType.PRIMARY_REGULAR,
    disabled: false,
    testID: 'submit-button',
  },
  onLoadingStateChange: () => {},
  showHeader: true,
};
